/*
 * Though RATE and MILLISECOND are fixed and both equal to 1000,
 * RATE does not HAVE to be 1000. It just happens to be the rate
 * that aligns with our Transcript data currently. MILLISECOND
 * is used in calculations where we are converting between seconds
 * and milliseconds. Whereas RATE is used in calculations related to
 * interval delay and playback speed.
 */

const RATE: number = 1000;
const MILLISECOND: number = 1000;

export { RATE, MILLISECOND };
